import { UnitSource } from "./NumberWithUnit";
import { UnitConversionFactor } from "./UnitConversionFactor";

export class UnitConversionFactorGroup {
    private readonly map: Map<String, UnitConversionFactor> = new Map();

    constructor(...conversionFactors: UnitConversionFactor[]) {
        (conversionFactors ?? []).forEach(factor => this.map.set(factor.id, factor));
    }

    public getConversionFactor(fromUnitAbbreviation: UnitSource, toUnit: UnitSource): UnitConversionFactor {
        const key = UnitConversionFactor.buildId(fromUnitAbbreviation, toUnit);
        return this.map.get(key);
    }
}
